import { __assign } from "tslib";
import { StyleSheet } from "react-native";
import { textStyle } from '../v2/theme';
export default StyleSheet.create({
  messageContainer: {
    marginTop: 20
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    flexDirection: "row"
  },
  tabPan: {
    height: "auto",
    overflow: "hidden",
    borderBottomWidth: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    color: "#006B95",
    backgroundColor: "#efefef",
    width: 100,
    marginRight: 2
  },
  selectedTab: {
    height: "auto",
    borderWidth: 1,
    borderColor: "#DDDDDD",
    borderBottomWidth: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    color: "#FFF",
    backgroundColor: "#006B95",
    marginRight: 2
  },
  tableContainer: {
    flex: 1,
    padding: 16,
    paddingTop: 30,
    backgroundColor: "#fff"
  },
  tableHead: {
    height: 40,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    backgroundColor: "#EFEFEF"
  },
  tableText: __assign({
    margin: 10
  }, textStyle.defaultTextDescription),
  tableTextHead: {
    margin: 10
  },
  tableRow: {
    flexDirection: "row",
    backgroundColor: "#EFEFEF"
  },
  composeHeader: {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  composeFooterLarge: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  composeFooterSmall: {
    width: '100%',
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center"
  },
  composeChildrenRight: {
    width: "50%",
    justifyContent: "space-between"
  },
  textviewSmall: {
    marginTop: 20,
    marginLeft: 20,
    display: "flex",
    flexDirection: "column"
  },
  textview: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    marginTop: 20,
    marginLeft: 20
  },
  select: {
    marginTop: 20,
    marginLeft: 20,
    width: 200
  },
  textviewSubjSmall: {
    marginTop: 20,
    marginLeft: 20,
    display: "flex",
    flexDirection: "column"
  },
  textViewSubj: {
    marginTop: 20,
    marginLeft: 20,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  textAreaContainer: {
    padding: 20
  },
  textArea: {
    width: "100%"
  },
  disclaimerCounter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  disclaimer: {
    marginTop: 15
  }
});